import { Link } from "react-router-dom";

export default function Nav() {
  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50"
      data-testid="top-nav"
      style={{
        background: "rgba(244,241,234,0.72)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderTop: "1px solid var(--line)",
        borderBottom: "1px solid var(--line)",
      }}
    >
      <div className="grid grid-cols-3 items-center h-[60px]">
        <div className="px-5 md:px-10" />
        <div
          className="h-full flex justify-center items-center"
          style={{ borderLeft: "1px solid var(--line)", borderRight: "1px solid var(--line)" }}
        >
          <Link to="/" aria-label="evove home" data-testid="nav-logo">
            <img
              src="/logo-evove.webp"
              alt="evove"
              className="logo-ink h-[20px] md:h-[22px] w-auto"
            />
          </Link>
        </div>
        <div className="px-5 md:px-10" />
      </div>
    </nav>
  );
}
